/**
 * Machine Jump — Skills-twin dial · related desks (not a roster filter).
 * Soft≠Live: Register is only on the rail foot.
 * Chrome shares mh-filter with Skills so the pair reads as one dial family.
 */
import { useEffect, useRef, useState } from "react";
import { html, M, stop, go } from "./ui.js";

const DIAL_IRIS = { type: "spring", stiffness: 460, damping: 30, mass: 0.62 };
const DIAL_OPT = { type: "tween", duration: 0.22, ease: [0.16, 1, 0.3, 1] };

export default function MachineJumpMenu({
  fromRoute,
  deviceId = "",
}) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (root.current && !root.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    const t = setTimeout(() => {
      addEventListener("pointerdown", onDoc, true);
      addEventListener("keydown", onKey);
    }, 0);
    return () => {
      clearTimeout(t);
      removeEventListener("pointerdown", onDoc, true);
      removeEventListener("keydown", onKey);
    };
  }, [open]);

  const close = () => setOpen(false);

  const rows = [
    {
      id: "groups",
      label: "Groups desk",
      say: "Open Cap targeting · assign claimed machines to dispatch groups",
      kind: "desk",
      run: () => { close(); go("/machine/groups"); },
    },
  ];
  const readyN = rows.length;

  return html`
    <div className="mh-filter mh-jump" ref=${root}
      data-open=${open ? "1" : "0"}
      data-on=${open ? "1" : "0"}
      data-compact="1"
      data-dial="1"
      data-jump="1"
      data-lux="1">
      <button type="button" className="mh-filter__trig mh-jump__trig"
        aria-haspopup="menu" aria-expanded=${open ? "true" : "false"}
        aria-label=${"Jump · " + readyN + " related desks"}
        title=${"Jump · related desks · Skills only filters this roster"}
        onClick=${(e) => { stop(e); setOpen((v) => !v); }}>
        <span className="mh-filter__copy mh-jump__copy">
          <small className="mh-filter__k mh-jump__k">Jump</small>
          <b className="mh-filter__v mh-jump__v">${open ? "Open" : "Desks"}</b>
        </span>
        <em className="mh-filter__n mh-jump__n" title="Related desks">${readyN}</em>
        <i className="mh-filter__chev mh-jump__chev" data-open=${open ? "1" : "0"} aria-hidden="true"/>
      </button>
      ${open ? html`
        <${M.div} className="mh-filter__pop mh-jump__pop" role="menu"
          aria-label="Jump · related desks"
          data-lux="1" data-motion="iris"
          style=${{ transformOrigin: "top center" }}
          initial=${{ opacity: 0, y: -12, scaleY: 0.82, filter: "blur(6px)" }}
          animate=${{ opacity: 1, y: 0, scaleY: 1, filter: "blur(0px)" }}
          exit=${{ opacity: 0, y: -8, scaleY: 0.9, filter: "blur(4px)" }}
          transition=${DIAL_IRIS}
          onClick=${stop}>
          <span className="mh-filter__pop-glow" aria-hidden="true"/>
          <span className="mh-filter__pop-scan" aria-hidden="true"/>
          <header className="mh-filter__hd mh-jump__hd">
            <span>Jump</span>
            <small>${readyN} desk · not a filter</small>
          </header>
          <p className="mh-jump__why">
            Skills filters this roster. Jump leaves it — open a related desk.
          </p>
          <div className="mh-filter__list mh-jump__list">
            ${rows.map((r, idx) => html`
              <${M.button} key=${r.id} type="button" role="menuitem"
                className="mh-filter__opt mh-jump__row"
                data-kind=${r.kind}
                data-on="0"
                title=${r.label + " · " + r.say}
                initial=${{ opacity: 0, x: -10 }}
                animate=${{ opacity: 1, x: 0 }}
                transition=${{ ...DIAL_OPT, delay: 0.04 + idx * 0.03 }}
                onClick=${() => r.run()}>
                <i className="mh-filter__mark mh-jump__mark" aria-hidden="true"/>
                <span className="mh-filter__opt-copy mh-jump__row-copy">
                  <b>${r.label}</b>
                  <small>${r.say}</small>
                </span>
              <//>`)}
          </div>
        <//>` : null}
    </div>`;
}
